import { IGroup } from '../interfaces/group';
import API from './base';

export const groupsAPI = new API('/groups');

export const getGroups = (): Promise<IGroup[]> => {
	return groupsAPI.post<null, IGroup[]>('search').then(response => response);
};
